import React, {useState, useEffect} from 'react';
import Navbar from '../components/Internal-nav';  
import CountertopCard from '../components/countertop-card';
import CountertopData from '../data/countertopdata.json';
import ContactBanner  from "../components/contact-banner";
import './domestic-countertops.scss';


function DomesticCountertop() {
  const [filteredCountertop, setFilteredCountertop] = useState(null);
  useEffect(() => {
    setFilteredCountertop(CountertopData.Countertops.filter(ptype => ptype.page === "domestic" || ptype.page === "all"));
  }, []);

  function filterCountertop(ctype) {
    let fcountertops = CountertopData.Countertops.filter(ctop => ctop.type === ctype).filter(ptype => ptype.page === "domestic" || ptype.page === "all");
    return fcountertops;
  }

  function handleCountertop(e) {
    let typeCountertop = e.target.value;
    typeCountertop !== "all"
      ? setFilteredCountertop(filterCountertop(typeCountertop))
      : setFilteredCountertop(CountertopData.Countertops.filter(ptype => ptype.page.includes("domestic") || ptype.page === "all"));
  }

  return (
    <div className='App'>
    <header>
      <Navbar />
    </header>
    <div>
      <div className='inner-banner'>
    <video id="background-video" autoPlay loop muted poster="../assets/example-countertop-banner.jpg">
      <source src="../assets/cnc.mp4" type="video/mp4" />
    </video>
      <div className='banner-content'>
        <h1>Explore our Countertop Options</h1>
        </div>
 </div>
      <div className='countertop-filter'>
        <div className='filter-content'>
          <h2>Choose your countertop material: </h2>
        </div>

      <div className='filter-buttons'>
        <button value="all" onClick={handleCountertop}>All</button>
        <button value="granite" onClick={handleCountertop}>Granite</button>
        <button value="quartz" onClick={handleCountertop}>Quartz</button>
      </div>
    </div>
    <> <div className='countertop-list'>
    {filteredCountertop ? 
            filteredCountertop.map((d,i) => (
            <CountertopCard key={i} data={d}></CountertopCard>
            ) 
            )
            : 'loading'}

      </div>
      </>
      <ContactBanner ></ContactBanner>
    </div>
    </div>
  );
};
  
export default DomesticCountertop;